import { Injectable } from '@angular/core';
import { Toast, ToastController } from 'ionic-angular';

@Injectable()
export class ToastService {

  toast: Toast;
  errorToastPresent: boolean = false;

  constructor(public toastCtrl: ToastController) { }

  create(message, ok = false, duration = 2000) {
    if (this.toast) {
      this.toast.dismiss();
    }

    this.toast = this.toastCtrl.create({
      message,
      duration: ok ? null : duration,
      position: 'bottom',
      showCloseButton: ok,
      closeButtonText: 'OK'
    });
    this.toast.present();
  }

  presentErrorToast(){
    if(this.errorToastPresent) return;
    this.errorToastPresent = true;
    let toast = this.toastCtrl.create({
      message: 'Our data provider is having an issue. This will be resolved soon, so please try again later.',
      showCloseButton: true,
      duration: 5000
    });
    toast.present();

    toast.onDidDismiss(() => {
      this.errorToastPresent = false;
    })

  }
}



// WEBPACK FOOTER //
// ./src/providers/util/toast.service.ts